import React, {useContext, useEffect} from 'react';
import {Link, useHistory} from 'react-router-dom';
import {NavLink} from 'react-router-dom';
import {makeStyles} from '@material-ui/core/styles';
import {
    Button,
    Box,
    Grid,
    Typography,
    Container,
    IconButton,
} from '@material-ui/core';
import {Anchor} from 'components/icons/icons';
import {AppCtx} from 'context/AppContext';
import {useFlags} from 'hooks';
import useBrowserTitle from 'hooks/useBrowserTitle';
import {ArrowBack} from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
    button: {
        backgroundColor: `${theme.palette.primary.light2}`,
        border: 0,
        borderRadius: 3,
        height: 70,
        width: 70,
        margin: '2px 30px',
        padding: '10px',
    },
}));

const iconProps = {
    height: 50,
    width: 50,
};

const FormTypeOption = ({
    formName,
    formPath,
    formDescription,
    icon: Icon,
    disabled,
}) => {
    const classes = useStyles();
    const {setInForm} = useContext(AppCtx);

    // This is pre-form so set form context
    useEffect(() => {
        setInForm(true);
        return () => {
            setInForm(false);
        };
    }, [setInForm]);

    return (
        <>
            <Button
                disabled={disabled}
                variant='contained'
                className={classes.button}
                to={formPath}
                component={Link}
            >
                <Icon {...iconProps} />
            </Button>

            <Typography align='center'>{formName}</Typography>
            {formDescription?.length > 0 && (
                <Typography align='center'>{formDescription}</Typography>
            )}
        </>
    );
};

const GoBackButton = () => {
    const history = useHistory();
    return (
        <IconButton
            color='default'
            onClick={() => {
                history.goBack();
            }}
            style={{border: '1px solid lightgray'}}
        >
            <ArrowBack />
        </IconButton>
    );
};

const AddSeaservice = () => {
    useBrowserTitle(`| Add Sea Service`);
    const classes = useStyles();
    const {ssl_form_active, cod_form_active, cg719s_form_active} = useFlags();

    return (
        <Container maxWidth='xs'>
            <Box textAlign='center'>
                <Grid
                    container
                    spacing={2}
                    direction='column'
                    justifyContent='flex-start'
                    alignItems='center'
                >
                    <Grid item />
                    <Grid item>
                        <Typography variant='h6' align='center'>
                            Great! Let's get started! What kind of Sea Service
                            Document are you adding?
                        </Typography>
                    </Grid>
                    <Grid item>
                        <FormTypeOption
                            formName='Letter on Official Letterhead'
                            icon={Anchor}
                            key='seaServiceLetter'
                            formPath={'/forms/ssl'}
                            disabled={!ssl_form_active}
                        />
                    </Grid>
                    <Grid item>
                        <FormTypeOption
                            formName='Certificate of Discharge'
                            icon={Anchor}
                            key='cod'
                            formPath={'/forms/cod'}
                            disabled={!cod_form_active}
                        />
                    </Grid>
                    <Grid item>
                        <FormTypeOption
                            formName='CG 719S'
                            formDescription='(Small Vessel Sea Service Form)'
                            icon={Anchor}
                            key='cg719s'
                            formPath={'/forms/cg719s'}
                            disabled={!cg719s_form_active}
                        />
                    </Grid>
                    <Grid item>
                        <Button
                            variant='contained'
                            className={classes.button}
                            component={NavLink}
                            to='/uniformedservice'
                        >
                            <Anchor height={50} width={50} />
                        </Button>
                        <Typography>Active Duty Sea Time</Typography>
                    </Grid>
                    <Grid item>
                        <GoBackButton />
                    </Grid>
                </Grid>
            </Box>
        </Container>
    );
};

export default AddSeaservice;
export {GoBackButton, FormTypeOption};
